(function () {
  'use strict';

  const CONFIG = {
    products: {
      'fusion': true,
      'personalized-perfume': true
    },
    variantKeywords: ['100ml personalized'],
    popupParam: 'buy_again_personalization_popup',
    popupTitle: 'Please select your personalization options'
  };

  if (!/\/cart\/?$/.test(window.location.pathname)) return;

  const url = new URL(window.location.href);
  const cartLinkId = url.searchParams.get('cart_link_id');
  const showPopupAfterReload =
    url.searchParams.get(CONFIG.popupParam) === '1';

  if (!cartLinkId && !showPopupAfterReload) return;
  if (window.__buyAgainPersonalizationRunning) return;

  window.__buyAgainPersonalizationRunning = true;

  const root = window.Shopify?.routes?.root || '/';
  const cartUrl = `${root}cart.js`;
  const cartUpdateUrl = `${root}cart/update.js`;

  function getProductHandle(item) {
    if (item.handle) return item.handle;
    if (item.product_handle) return item.product_handle;

    if (item.url) {
      const match = item.url.match(/\/products\/([^/?#]+)/);
      if (match) return match[1];
    }

    return '';
  }

  function hasPersonalization(item) {
    const properties = item.properties || {};

    return Object.entries(properties).some(([key, value]) => {
      if (!key || key.startsWith('_')) return false;

      return (
        value !== null &&
        value !== undefined &&
        String(value).trim() !== ''
      );
    });
  }

  function isPersonalizationProduct(item) {
    const handle = getProductHandle(item);

    if (CONFIG.products[handle]) {
      return true;
    }

    const variantTitle = String(
      item.variant_title || ''
    ).toLowerCase();

    return CONFIG.variantKeywords.some(
      keyword => variantTitle.includes(keyword)
    );
  }

  function isInvalidItem(item) {
    return (
      isPersonalizationProduct(item) &&
      !hasPersonalization(item)
    );
  }

  function getInvalidItems(cart) {
    if (!Array.isArray(cart?.items)) return [];

    return cart.items.filter(isInvalidItem);
  }

  async function getCart() {
    const response = await fetch(cartUrl, {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      },
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error('Unable to read cart.');
    }

    return response.json();
  }

  async function getCartWithRetry() {
    const delays = [300, 700, 1200];
    let lastError;

    for (const delay of delays) {
      await new Promise(resolve => setTimeout(resolve, delay));

      try {
        const cart = await getCart();

        if (Array.isArray(cart?.items)) {
          return cart;
        }
      } catch (error) {
        lastError = error;
      }
    }

    throw lastError || new Error('Unable to load cart.');
  }

  async function removeItems(invalidItems) {
    const updates = {};

    invalidItems.forEach(item => {
      if (item.key) {
        updates[item.key] = 0;
      }
    });

    if (!Object.keys(updates).length) {
      throw new Error('No cart lines found.');
    }

    const response = await fetch(cartUpdateUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        updates
      })
    });

    if (!response.ok) {
      throw new Error(
        'Shopify could not update the cart.'
      );
    }

    const updatedCart = await response.json();

    const removedKeys = Object.keys(updates);

    const remainingInvalidItems =
      getInvalidItems(updatedCart).filter(item =>
        removedKeys.includes(item.key)
      );

    if (remainingInvalidItems.length > 0) {
      throw new Error(
        'Personalized items could not be removed.'
      );
    }

    return updatedCart;
  }

  function showPopup() {
    if (
      document.getElementById(
        'buy-again-personalization-modal'
      )
    ) {
      return;
    }

    const modal = document.createElement('div');

    modal.id =
      'buy-again-personalization-modal';

    modal.innerHTML = `
      <div class="buy-again-personalization-overlay"></div>
      <div
        class="buy-again-personalization-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="buy-again-personalization-title"
      >
        <div class="buy-again-personalization-content">
          <h2 id="buy-again-personalization-title"></h2>
          <button
            type="button"
            class="buy-again-personalization-ok"
          >
            OK
          </button>
        </div>
      </div>
    `;

    const title = modal.querySelector('h2');
    const button = modal.querySelector(
      '.buy-again-personalization-ok'
    );

    if (!title || !button) return;

    title.textContent = CONFIG.popupTitle;

    document.body.appendChild(modal);

    document.documentElement.style.overflow = 'hidden';

    button.focus();

    button.addEventListener('click', () => {
      document.documentElement.style.removeProperty(
        'overflow'
      );

      modal.remove();
    });
  }

  function showErrorPopup() {
    if (
      document.getElementById(
        'buy-again-personalization-modal'
      )
    ) {
      return;
    }

    const modal = document.createElement('div');

    modal.id =
      'buy-again-personalization-modal';

    modal.innerHTML = `
      <div class="buy-again-personalization-overlay"></div>
      <div
        class="buy-again-personalization-dialog"
        role="dialog"
        aria-modal="true"
      >
        <div class="buy-again-personalization-content">
          <h2>Unable to update your cart</h2>
          <button
            type="button"
            class="buy-again-personalization-ok"
          >
            Reload
          </button>
        </div>
      </div>
    `;

    document.body.appendChild(modal);

    document.documentElement.style.overflow = 'hidden';

    const button = modal.querySelector(
      '.buy-again-personalization-ok'
    );

    if (!button) {
      document.documentElement.style.removeProperty(
        'overflow'
      );

      modal.remove();
      return;
    }

    button.focus();

    button.addEventListener('click', () => {
      window.location.reload();
    });
  }

  async function init() {
    try {
      if (showPopupAfterReload) {
        url.searchParams.delete(
          CONFIG.popupParam
        );

        window.history.replaceState(
          window.history.state,
          '',
          url.toString()
        );

        showPopup();
        return;
      }

      const cart = await getCartWithRetry();
      const invalidItems = getInvalidItems(cart);

      if (!invalidItems.length) {
        return;
      }

      await removeItems(invalidItems);

      const popupUrl =
        new URL(window.location.href);

      popupUrl.searchParams.set(
        CONFIG.popupParam,
        '1'
      );

      window.location.href =
        popupUrl.toString();

    } catch (error) {
      console.error(
        '[Buy Again Personalization]',
        error
      );

      showErrorPopup();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      { once: true }
    );
  } else {
    init();
  }
})();